/**
 * 棋牌游戏首页
 */
import { connect } from 'react-redux'
import RichHeader from './RichHeader.jsx';
import MainFooter from '../../components/footers/Original_Main.jsx'
import Entrance from '../../components/entrance/entrance.jsx';
import KGameModal from './KGameModal.jsx';

class Chess extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      platform: '',
      kgamemodal: false
    }
  }

  componentDidMount() {
   
  }

  // 直接进入平台
  openTransfer(platform) {
    if (!this.checkPlatformState(platform)) {
      return;
    }
    if(this.props.__USER.toJS().platform_profile[platform.toLowerCase()].code == 30301){
      this.props.$$BASE.openAlert('请先进入游戏后再转账,谢谢!');
      return;
    }
    this.props.$$BASE.openOverlay();
    this.props.$$BASE.openTransferModal(platform)
  }


  checkPlatformState(platform) {
    platform = _.toLower(platform);
    const __user = this.props.__USER.toJS();
    if (__user.platform_profile[platform].code == 30300) {
      this.props.$$BASE.openToast('您未开通！请联系您的上级');
      return false;
    }
    if (!__user.platform_profile[platform].onload) {
      this.props.$$BASE.openToast('平台数据加载中，请稍后...');
      return false;
    }
    return true;
  }

  // 进入游戏
  enterGame(url, platform) {
    if (!this.checkPlatformState(platform)) {
      return;
    }
    if(platform === 'kgame'){
      return this.setState({kgamemodal: true});
    }
    window.open(url);
  }

  // 关闭kgame游戏弹窗
  closeModal() {
    this.setState({kgamemodal: false})
  }

  render() {
    const __user = this.props.__USER.toJS();
    return (
      <div className="chess-outbox">
        <div className="chess-container" key='casino'>
          <div>
            <RichHeader />
            <div className="zryx_banner clearfix">
              <div className="content">
                <div className="zryx_enter yy-chess">
                  <Entrance money={__user.balance.yy} gameName="云游棋牌" imgname='qpyy' transferFn={this.openTransfer.bind(this, "YY")} url={this.enterGame.bind(this, "/yygame/play", 'yy')} />
                </div>
                <div className="zryx_enter kgame-chess">
                  <Entrance money={__user.balance.kgame} gameName="KGAME" imgname='qpkgame' transferFn={this.openTransfer.bind(this, "KGAME")} url={this.enterGame.bind(this, "/kgame/play", 'kgame')} />
                </div>
                <div className="zryx_enter wali-chess">
                  <Entrance money={__user.balance.wali} gameName="瓦力棋牌" imgname='qpwali' transferFn={this.openTransfer.bind(this, "WALI")} url={this.enterGame.bind(this, "/waligame/play", 'wali')} />
                </div>
              </div>
            </div>
            <MainFooter />
            {
              this.state.kgamemodal &&
              <KGameModal 
                frameSrc="/kgame/play"
                close={this.closeModal.bind(this)}
                transferFn={this.openTransfer.bind(this, "KGAME")}
              />
            }
          </div>
        </div>
      </div>
    );

  }
}

reactMixin(Chess.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __USER: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$USER: bindActionCreators(userAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Chess)